import React from 'react';
import ComplaintsForm from '../../../../shared/inquiry-form-customer';
import environment from 'environment';

const ComplaintsContent = () => {    
    return(        
        <section className="section-home-improvement-form">            
            <div className="row paragraph">                     
                <p className="title-customers brandon-bold text-120 mt-40">Please complete the form below to submit a complaint to our resolution team. </p>
            </div>   
            <div className="inquiry-form row mt-20 mb-20">                    
                <ComplaintsForm     
                    form="inquiry.consumer.complaints"                                       
                    email={environment.communications.consumerComplaints}                            
                    paragraph="none" 
                    disclaimerTextColor="text-white"
                    closeButton="false"                       
                />                              
            </div>                
        </section>        
    )    
}

export default ComplaintsContent;
